/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ItauAtualizacaoCobrancaRecorrente } from './itauAtualizacaoCobrancaRecorrente';

export interface ItauTentativaCobrancaRecorrente {
  atualizacao?: Array<ItauAtualizacaoCobrancaRecorrente>;
  dataLiquidacao?: string;
  endToEndId?: string;
  status?: ItauTentativaCobrancaRecorrente.StatusEnum;
  tipo?: ItauTentativaCobrancaRecorrente.TipoEnum;
}
export namespace ItauTentativaCobrancaRecorrente {
  export type TipoEnum = 'AGND' | 'NTAG' | 'RIFL';
  export const TipoEnum = {
    AGND: 'AGND' as TipoEnum,
    NTAG: 'NTAG' as TipoEnum,
    RIFL: 'RIFL' as TipoEnum
  };
  export type StatusEnum =
    | 'AGENDADA'
    | 'PAGA'
    | 'CANCELADA'
    | 'REJEITADA'
    | 'EXPIRADA'
    | 'SOLICITADA';
  export const StatusEnum = {
    AGENDADA: 'AGENDADA' as StatusEnum,
    PAGA: 'PAGA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    SOLICITADA: 'SOLICITADA' as StatusEnum
  };
}
